import { withStyles } from '@material-ui/core/styles';

import EditForm from '../maintainer/edit';
import Form from './form';
import Service from '../../services/region-service';
import { isRequired } from '../../libraries/validators';
import { reduceSpaces } from '../../libraries/utils';
import { editionMaintainer as styles } from '../maintainer/styles';

const Edit = props => {
  const service = Service;

  const getErrors = values => {
    const errors = {};
    const minimumValues = { code: values.code, name: values.name, order: values.order };
    const newValues = Object.entries(minimumValues).reduce(reduceSpaces, {});
    isRequired(errors, newValues);
    return errors;
  };

  return {
    getErrors,
    service,
    keyName: 'id'
  };
};

export default withStyles(styles)(EditForm(Edit)(Form));
